module.exports = __webpack_public_path__ + "img/journey.0f8cc415.svg";